import {
    INTERIOR_COUNTRY_CODE,
    PRODUCT_TYPE,
    WEBSITES,
} from '@/constants/config';

export const PAYMENT_METHODS = {
    BANK_TRANSFER: {
        key: 'BANK_TRANSFER',
        label: 'Wire',
        epicLabel: 'Wire',
        value: 'banktransfer',
        className: 'bg-navy-blue text-white',
    },
    PAY_WAY: {
        key: 'PAY_WAY',
        label: 'PayWay ABA',
        epicLabel: 'PayWay',
        type: 'ABA',
        value: 'aba_payway',
        className: 'bg-dark-cerulean text-white',
        feeTranslateKey: 'invoices.payway_fee',
        content:
            '<span>Pay<span class="text-robin-egg-blue">Way</span> ABA</span>',
    },
    PAY_WAY_CARDS: {
        key: 'PAY_WAY_CARDS',
        label: 'PayWay Cards',
        epicLabel: 'PayWay',
        type: 'Card',
        value: 'cards_payway',
        className: 'bg-dark-cerulean text-white',
        feeTranslateKey: 'invoices.payway_fee',
        content:
            '<span>Pay<span class="text-robin-egg-blue">Way</span> <span class="text-sunglow"> Card</span></span>',
    },
    PAY_WAY_PLUS: {
        key: 'PAY_WAY_PLUS',
        label: 'PayWay Plus',
        epicLabel: 'PayWay Plus',
        value: 'payway_plus',
        className: 'bg-dark-cerulean text-white',
        content:
            '<span>Pay<span class="text-robin-egg-blue">Way</span> <span class="text-coral">Plus</span></span>',
    },
    BALANCE: {
        key: 'BALANCE',
        label: 'Wallet',
        epicLabel: 'Wallet',
        value: 'BALANCE',
        className: 'bg-cinnabar text-white',
        content: '<span class="bg-cinnabar text-white">Wallet</span>',
    },
    PAYPAL: {
        key: 'paypal',
        label: 'PayPal',
        epicLabel: 'PayPal',
        value: 'PAYPAL',
        className: 'bg-sunglow',
        feeTranslateKey: 'invoices.payment_fee',
        content:
            '<span class="text-resolution-blue">Pay<span class="text-cerulean">Pal</span></span>',
    },
    PROMO_CREDIT: {
        key: 'PROMO_CREDIT',
        label: 'Promo Credit',
        epicLabel: 'Promo Credit',
        value: 'PROMO_CREDIT',
        className: 'bg-light-sea-green',
        content:
            '<span class="bg-light-sea-green text-white">Promo Credit</span>',
    },
    STRIPE: {
        key: 'STRIPE',
        label: 'Stripe',
        epicLabel: 'Stripe',
        value: 'stripe',
        className: 'bg-cornflower-blue text-white',
    },
    MINI_APP: {
        key: 'MINI_APP',
        label: 'Mini App',
        epicLabel: 'Mini App',
        value: 'MINI_APP',
        className: 'bg-dark-cerulean text-white',
        content: '<span>Mini <span class="text-red-ribbon">App</span></span>',
    },
    OMISE: {
        key: 'OMISE',
        label: 'Omise',
        epicLabel: 'Omise',
        value: 'omise',
        className: 'bg-aquamarine text-ebony',
    },
    CASH: {
        key: 'CASH',
        label: 'Cash',
        epicLabel: 'Cash',
        value: 'cash',
        className: 'bg-ocean-green text-white',
    },
};

export const VISIBLE_BANK_INFO_METHOD = [PAYMENT_METHODS.BANK_TRANSFER.key];

export const PAYMENT_PRODUCT_TYPES = {
    ...PRODUCT_TYPE,
    AWS: 'AWS',
};

export const ACCEPTED_ALL_COUNTRIES = '*';
export const ACCEPTED_ALL_WEBSITES = '*';

/**
 * @define isEnable - enable or disable that payment method
 * @define acceptedCountries - List of country accept the payment method, "*" is accepted all
 * @define unacceptedCountries - List of country reject the payment method, empty is no country is rejected
 * @define isStateful - The payment method always show (when enabled) after user used that
 * @define forceShowProducts - Force show when payment contain product in array, even disabled
 * @define acceptedWebsites - List of website accept the payment method, "*" is accepted all
 * @define isCheckTaxIncluded - If true, it will show when the invoice has Tax. If false, it will show whether the invoice has tax or not.
 *
 * @summary acceptedCountries, unacceptedCountries, acceptedWebsites, isStateful, isCheckTaxIncluded has precondition is isEnable
 * forceShowProducts ignores isEnable condition
 */
export const PAYMENT_OPTIONS = {
    BANK: {
        key: 'banktransfer',
        name: 'Wire Banking Transfer',
        value: 'banktransfer',
        isEnable:
            process.env.VUE_APP_ENABLE_PAYMENT_METHOD_BANK_TRANSFER?.toLowerCase() ===
            'true',
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: [PAYMENT_PRODUCT_TYPES.AWS],
        acceptedWebsites: [WEBSITES.TH],
        isCheckTaxIncluded: false,
    },
    PAY_WAY_ABA: {
        key: 'aba_payway',
        name: 'PayWay ABA',
        value: 'aba_payway',
        isEnable:
            process.env.VUE_APP_ENABLE_PAYWAY_METHOD?.toLowerCase() === 'true',
        isStateful: true,
        acceptedCountries: [INTERIOR_COUNTRY_CODE.KH, INTERIOR_COUNTRY_CODE.TH],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [WEBSITES.KH],
        isCheckTaxIncluded: true,
    },
    PAY_WAY_CARDS: {
        key: 'cards_payway',
        name: 'PayWay Credit card',
        value: 'cards_payway',
        isEnable:
            process.env.VUE_APP_ENABLE_PAYWAY_METHOD?.toLowerCase() === 'true',
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [WEBSITES.KH],
        isCheckTaxIncluded: false,
    },
    PAY_WAY_PLUS: {
        key: 'payway_plus',
        name: 'PayWay Credit card',
        value: 'payway_plus',
        isEnable:
            process.env.VUE_APP_ENABLE_PAYMENT_METHOD_PAYWAY_PLUS?.toLowerCase() ===
            'true',
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [WEBSITES.KH],
        isCheckTaxIncluded: false,
    },
    ACCOUNT_BALANCE: {
        key: 'balance',
        name: 'Account Balance',
        value: 'balance',
        isEnable: true,
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [ACCEPTED_ALL_WEBSITES],
        isCheckTaxIncluded: false,
    },
    PROMO_CREDIT: {
        key: 'promo_credit',
        name: 'Promo Credit',
        value: 'promo_credit',
        isEnable: false,
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [],
        isCheckTaxIncluded: false,
    },
    STRIPE: {
        key: 'stripe',
        name: 'Stripe',
        value: 'stripe',
        isEnable:
            process.env.VUE_APP_ENABLE_STRIPE_METHOD?.toLowerCase() === 'true',
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [WEBSITES.AE],
        isCheckTaxIncluded: false,
    },
    OMISE: {
        key: 'omise',
        name: 'Omise',
        value: 'omise',
        isEnable:
            process.env.VUE_APP_ENABLE_PAYMENT_METHOD_OMISE?.toLowerCase() ===
            'true',
        isStateful: false,
        acceptedCountries: [ACCEPTED_ALL_COUNTRIES],
        unacceptedCountries: [],
        forceShowProducts: null,
        acceptedWebsites: [WEBSITES.TH],
        isCheckTaxIncluded: false,
    },
};

export const SITE_PAYMENT_OPTIONS = {
    [WEBSITES.KH]: {
        BANK: PAYMENT_OPTIONS.BANK,
        PAY_WAY_ABA: PAYMENT_OPTIONS.PAY_WAY_ABA,
        PAY_WAY_CARDS: PAYMENT_OPTIONS.PAY_WAY_CARDS,
        PAY_WAY_PLUS: PAYMENT_OPTIONS.PAY_WAY_PLUS,
        ACCOUNT_BALANCE: PAYMENT_OPTIONS.ACCOUNT_BALANCE,
        PROMO_CREDIT: PAYMENT_OPTIONS.PROMO_CREDIT,
    },
    [WEBSITES.AE]: {
        ACCOUNT_BALANCE: PAYMENT_OPTIONS.ACCOUNT_BALANCE,
        STRIPE: PAYMENT_OPTIONS.STRIPE,
    },
    [WEBSITES.TH]: {
        OMISE: PAYMENT_OPTIONS.OMISE,
        BANK: PAYMENT_OPTIONS.BANK,
        ACCOUNT_BALANCE: PAYMENT_OPTIONS.ACCOUNT_BALANCE,
    },
};
export const DEFAULT_PAYMENT_OPTIONS = {
    [WEBSITES.KH]: PAYMENT_OPTIONS.PAY_WAY_PLUS,
    [WEBSITES.AE]: PAYMENT_OPTIONS.STRIPE,
    [WEBSITES.TH]: PAYMENT_OPTIONS.OMISE,
};

export const PAY_WAY_OPTIONS = {
    PAY_WAY_ABA: 'abapay',
    PAY_WAY_CARDS: 'cards',
};

export const INTERIOR_PAYMENT_METHOD = {
    KH: [PAYMENT_OPTIONS.PAY_WAY_ABA.value],
    AE: [],
    TH: [],
};

export const PAYMENT_METHOD_MIN_PRICES = {
    [PAYMENT_OPTIONS.STRIPE.key]: 2,
    [PAYMENT_OPTIONS.PAY_WAY_ABA.key]: 0,
    [PAYMENT_OPTIONS.PAY_WAY_CARDS.key]: 0,
    [PAYMENT_OPTIONS.PAY_WAY_PLUS.key]: 0,
    [PAYMENT_OPTIONS.BANK.key]: 0,
    [PAYMENT_OPTIONS.ACCOUNT_BALANCE.key]: 0,
    [PAYMENT_OPTIONS.PROMO_CREDIT.key]: 0,
    [PAYMENT_OPTIONS.OMISE.key]: 20,
};

export const PAYMENT_METHOD_MAXIMUM_AMOUNTS = {
    [PAYMENT_OPTIONS.PAY_WAY_PLUS.key]: 10000,
    [PAYMENT_OPTIONS.PAY_WAY_CARDS.key]: 10000,
    [PAYMENT_OPTIONS.OMISE.key]: 330000,
    [PAYMENT_OPTIONS.PAY_WAY_ABA.key]: 10000,
    [PAYMENT_OPTIONS.STRIPE.key]: 37000,
};

export const ENCRYPTION_PAYMENT_OPTION_KEYS = [
    PAYMENT_OPTIONS.STRIPE.key,
    PAYMENT_OPTIONS.OMISE.key,
];

export const PAYMENT_STATUS_CODES = {
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
};

export const PAYMENT_BANK_TRANSFER_INFO = {
    [WEBSITES.KH]: {
        bankName: 'ABA BANK',
        accountName: 'K ZONE TECH CO LTD',
        accountNumber: '002792490',
        swiftCode: 'ABAAKHPP',
    },
    [WEBSITES.TH]: {
        bankName: 'KASIKORN BANK',
        accountName: 'K ZONE CO., LTD',
        accountNumber: '196-8-09287-8',
        swiftCode: 'KASITHBK',
        branch: 'CENTRAL EASTVILLE',
        branchCode: '0955',
    },
};

export const CHARGE_ACTIONS = {
    ADD_CARD: 'ADD_CARD',
    PAYMENT_ORDER: 'PAYMENT_ORDER',
    PAYMENT_TOP_UP: 'PAYMENT_TOP_UP',
};
